import { ChangeDetectorRef, Component, Inject, OnInit,LOCALE_ID,ViewRef } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { first } from 'rxjs/operators'
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import {  DialogService, DroitsService, StateService,
MesVaccinService
 } from '../../../../../services'

import { EventEmitter,Output} from '@angular/core'

import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';


const KEY = 'mesvaccins-associate-dialog'

@Component({
  selector: 'atyl-mesvaccins-associate',
  templateUrl: './mesvaccins-associate.component.html',
  styleUrls: ['./mesvaccins-associate.component.scss'],
	 providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ]
})
@Stringable({
  path: "views/partials/layout/dialogs/mesvaccins-associate-dialog",
  key: KEY,
})
export class MesVaccinsAssociateComponent extends BaseDialogComponent implements OnInit {

  @StringableValues(KEY) strings: any
  
  
  dossier:any;
   
  datenaissInput: any
  nomInput: string = '';
  prenomInput: string = ''; 
   
  searched: any[] = [];   
  selectedSearch:any;
  loading:boolean=false; 
  @Output() onFormClosed = new EventEmitter<any>();  

  constructor(
    public dialogRef: MatDialogRef<MesVaccinsAssociateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    public droitsService: DroitsService,
    dialogService: DialogService,
    private stateService: StateService,
    private mesVaccinsService: MesVaccinService
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
	if (this.data && this.data.dossier) {
        this.dossier = this.data.dossier;
        
        this.nomInput=this.dossier.tiers.NOM;
        this.prenomInput=this.dossier.tiers.PRENOM;
        this.datenaissInput=this.dossier.tiers.DATENAISSANCE;
        console.log("MesVaccinsAssociateComponent birth date", this.datenaissInput)
    }
	
	
    
	}
  
  detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
    searchByDossier() {
		
		
		
	}
    
  	search(event:any) {
		  
		let _ops={
		       	nom: this.nomInput,
		       	prenom: this.prenomInput,
		       	datenaissance: this.datenaissInput	
				}
	    this.searched=[]; 
	    this.loading=true;
	    this.mesVaccinsService.searchbyitems(_ops).subscribe(
				(res: JSONRpcResponse) => {
					this.loading=false;
					console.log("search MesVaccinsAssociateComponent",res.result);
					/*res.result={
					    "similar_patients": [
					        {
					            "score": 21.125479,
					            "patient": {
					                "id": 417059,
					                "first_name": "Miguelito",
					                "last_name": "Sanchez",
					                "birth_date": "2000-12-12",
					                "record_uuid": "97249e59-f1d8-4090-a6df-1ca2d599ccac"
					            }
					        }
					    ]
					};*/
					if (res.result.length>0) {
						this.searched=res.result; 
						
						
						
						
					};
					this.detectChanges();
					
	    });
  	}
  	
  	save(event:any) {
		  if (this.selectedSearch) {
			   let _ops={
		       	MV_ID: this.selectedSearch.id
		     /*  	MV_UUID: this.selectedSearch.record_uuid*/
		       
				};
 				this.mesVaccinsService.set(this.dossier.ID,_ops).subscribe(
					 (res: JSONRpcResponse) => {
						 console.log("save MesVaccinsAssociateComponent",this.dossier.ID,_ops,res);
						 this.stateService.updateDossier(res.result);
						 this.detectChanges();
					 }
			)
    
		  }
    }
  
}
